/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ThreadInputs from '../../components/ThreadInputs/ThreadInputs';
import { connect } from 'react-redux';
import { updateThreadRequestAction } from '../../store/thread/threadActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateThread = ({ updateThreadRequest, isLoading, updateThreadData, threadList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const threadFromList = threadList?.find(t => t.ThreadId?.toString() === id);
  const threadData = location.state?.thread || threadFromList || null;

  useEffect(() => {
    if (!threadData && id) {
      console.warn('No thread status data found in route state. You may need to fetch by ID:', id);
    }
  }, [threadData, id]);

  const handleSubmit = (data) => {
    updateThreadRequest({ data}, navigate);
  };

  const handleBackToThread = () => {
    navigate('/thread');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/thread" onClick={(e) => { e.preventDefault(); handleBackToThread(); }}>
          {t('thread')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateThreadStatus')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateThreadStatus')}</h4>
              {threadData?.ThreadId && (
                <small className="text-muted">ID: {threadData.ThreadId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {threadData ? (
                <ThreadInputs
                  onSubmit={handleSubmit}
                  onCancel={handleBackToThread}
                  isLoading={isLoading}
                  submitResponse={updateThreadData}
                  initialData={threadData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <div className="text-muted">
                    {t('No thread status data found. Please go back to the thread list.')}
                  </div>
                  <button 
                    className="btn btn-primary mt-3"
                    onClick={handleBackToThread}
                  >
                    {t('Back to Thread')}
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateThreadData: state.threadReducer.updateThreadData,
  threadList: state.threadReducer.threadList || [],
});

const mapDispatchToProps = (dispatch) => ({
  updateThreadRequest: (payload) => dispatch(updateThreadRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateThread);
